import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fb",
  "use": "icon-fb-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"icon-fb\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.05 7.615l.33-2.489H4.849v-1.59c0-.72.205-1.21 1.267-1.21l1.354-.002V.099A18.908 18.908 0 005.496 0c-1.952 0-3.29 1.16-3.29 3.291v1.835H0v2.489h2.206V14h2.642V7.615H7.05z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol